import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { usePageData } from '../../../core/PageData';

const PageTitle = () => {
  const direction = 'column';
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()

  return (
    <div
      id='sai_page_title'
      data-sai-swapper='true'
      data-sai-swapper-mode='prepend'
      data-sai-swapper-parent="{default: '#sai_content_container', 'lg': '#sai_toolbar_container'}"
      className='page-title d-flex flex-wrap me-3 flex-column justify-content-center'
    >
      {pageTitle && <h1
        className={clsx('page-heading d-flex text-dark fw-bold fs-3 my-0', {
          'flex-column justify-content-center': "column",
          'align-items-center': !"column",
        })}
      >
        {pageTitle}
        {pageDescription && <span
          className='page-desc text-muted fs-7 fw-semibold pt-2'
        >
          {direction === 'row' && (
            <span className='h-20px border-1 border-gray-300 border-start ms-3 mx-2'></span>
          )}
          {pageDescription} {' '}
        </span>}
      </h1>}

      {pageBreadcrumbs && pageBreadcrumbs.length > 0 && (
        <>
          {direction === 'row' && (
            <span className='h-20px border-gray-300 border-start mx-4'></span>
          )}
          <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
            {Array.from(pageBreadcrumbs).map((item, index) => (
              <li
                className={clsx('breadcrumb-item', {
                  'text-dark': !item.isSeparator && item.isActive,
                  'text-muted': !item.isSeparator && !item.isActive,
                })}
                key={`${item.path}${index}`}
              >
                {!item.isSeparator ? (
                  <Link className='text-muted text-hover-primary' to={item.path}>
                    {item.title}
                  </Link>
                ) : (
                  <span className='bullet bg-gray-200 w-5px h-2px'></span>
                )}
              </li>
            ))}
            <li className='breadcrumb-item text-dark'>{pageTitle}</li>
          </ul>
        </>
      )}
    </div>
  )
}

export default PageTitle;